module.exports = __webpack_public_path__ + "static/media/Akemi_6921.9986bc11.jpg";